import { USER_LOADED, USER_LOAD_FAILED } from 'redux/actionTypes/user';
import initialState from 'redux/reducers/user/initialState';
import userLoaded from 'redux/reducers/user/userLoaded';
import userLoadFailed from 'redux/reducers/user/userLoadFailed';
var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case USER_LOADED:
      {
        return userLoaded(state, action);
      }
    case USER_LOAD_FAILED:
      {
        return userLoadFailed(state, action);
      }
    default:
      {
        return state;
      }
  }
};
export default userReducer;